import React from "react"
import { connect } from "react-redux"

import { Icon as AIcon, Collapse, Button } from "antd"

import styled from "styled-components"
import { getIntegrationIcon } from "./"
import EmptyState from "../../core/components/EmptyState"
import { MergeIcon } from "../../core/icons"

const Panel = Collapse.Panel
const PanelStyled = styled(Panel)`
  box-shadow: 0 2px 14px 0 rgba(4, 25, 52, 0.14);
  .ant-collapse-content {
    border-top: 0px !important;
    .ant-collapse-content-box {
      display: flex;
    }
  }
`
const IntegrationIcon = styled.div`
  .integration-label {
    font-size: 16px;
    padding-top: 7px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  text-transform: capitalize;
  border-radius: 2px;
  i {
    color: #31b59f;
    font-size: x-large;
    border: 1px solid #dce;
    border-radius: 100%;
    background: white;
    position: absolute;
    margin: 45px 20px;
    padding: 2px;
  }
  &:hover {
    img {
      filter: drop-shadow(0px 0px 2px grey);
    }
  }
  cursor: pointer;
  ${props =>
    !props.checked &&
    `
    img {
      filter: saturate(50%) opacity(50%);
    }
  `};
`

class Integrations extends React.Component {
  state = (this.props.enabled || []).reduce(
    (a, c) => ({ ...a, [c]: false }),
    {}
  )

  render() {
    return (
      <div>
        <Collapse
          bordered={false}
          defaultActiveKey={this.props.enabled.length && ["1"]}
        >
          <PanelStyled
            header={"SEND TO INTEGRATIONS"}
            key="1"
            style={{
              border: 0
            }}
          >
            {this.props.enabled.length > 0 ? (
              <div style={{ position: "absolute", right: 30 }}>
                <a onClick={this.props.showIntegrationsModal}>
                  Manage <AIcon type="edit" />
                </a>
              </div>
            ) : (
              <EmptyState
                title="No enabled integrations yet."
                onClick={this.props.showIntegrationsModal}
                buttonText="Add Integration"
                icon={MergeIcon}
              />
            )}
            {this.props.enabled.map(integration => (
              <IntegrationIcon
                onClick={() => this.toggle(integration)}
                value={integration}
                checked={this.state[integration]}
              >
                <img
                  width="80"
                  title={"Send to " + integration}
                  src={getIntegrationIcon(integration)}
                />
                <div className="integration-label">{integration}</div>
                {this.state[integration] && <AIcon type="check" />}
              </IntegrationIcon>
            ))}
          </PanelStyled>
        </Collapse>
      </div>
    )
  }

  toggle = value => {
    this.setState({ [value]: !this.state[value] }, () =>
      this.props.onChange(
        Object.keys(this.state).filter(key => this.state[key])
      )
    )
  }
}

export default Integrations



// WEBPACK FOOTER //
// ./src/account/integrations/Integrations.js